export var VariantTypes;
(function (VariantTypes) {
    VariantTypes[VariantTypes["VARIANT_CHESS"] = 1] = "VARIANT_CHESS";
    VariantTypes[VariantTypes["VARIANT_CHESS960"] = 2] = "VARIANT_CHESS960";
})(VariantTypes || (VariantTypes = {}));
export var EloTypes;
(function (EloTypes) {
    EloTypes[EloTypes["ALL"] = 1] = "ALL";
    EloTypes[EloTypes["LIVE"] = 2] = "LIVE";
    EloTypes[EloTypes["BULLET"] = 3] = "BULLET";
    EloTypes[EloTypes["BLITZ"] = 4] = "BLITZ";
    EloTypes[EloTypes["RAPID"] = 5] = "RAPID";
    EloTypes[EloTypes["DAILY"] = 6] = "DAILY";
})(EloTypes || (EloTypes = {}));
export var ResultTypes;
(function (ResultTypes) {
    ResultTypes[ResultTypes["DRAW"] = 0] = "DRAW";
    ResultTypes[ResultTypes["WHITE_WINNS"] = 1] = "WHITE_WINNS";
    ResultTypes[ResultTypes["BLACK_WINNS"] = 2] = "BLACK_WINNS";
    ResultTypes[ResultTypes["DRAW_TEST"] = 3] = "DRAW_TEST";
})(ResultTypes || (ResultTypes = {}));
export var UserResultTypes;
(function (UserResultTypes) {
    UserResultTypes[UserResultTypes["WIN"] = 1] = "WIN";
    UserResultTypes[UserResultTypes["LOSE"] = 2] = "LOSE";
    UserResultTypes[UserResultTypes["DRAW"] = 3] = "DRAW";
})(UserResultTypes || (UserResultTypes = {}));
export var StatusTypes;
(function (StatusTypes) {
    StatusTypes[StatusTypes["TIME_UP"] = 1] = "TIME_UP";
    StatusTypes[StatusTypes["QUIT"] = 2] = "QUIT";
    StatusTypes[StatusTypes["CHECK_MATE"] = 3] = "CHECK_MATE";
    StatusTypes[StatusTypes["RESIGN"] = 4] = "RESIGN";
    StatusTypes[StatusTypes["STALE_MATE"] = 5] = "STALE_MATE";
    StatusTypes[StatusTypes["DRAW"] = 6] = "DRAW";
    StatusTypes[StatusTypes["THREEFOLD_REPETITION"] = 7] = "THREEFOLD_REPETITION";
    StatusTypes[StatusTypes["ABORT"] = 8] = "ABORT";
})(StatusTypes || (StatusTypes = {}));
export var ModeIds;
(function (ModeIds) {
    ModeIds[ModeIds["CHESS960"] = 2] = "CHESS960";
    ModeIds[ModeIds["BULLET"] = 3] = "BULLET";
    ModeIds[ModeIds["BLITZ"] = 4] = "BLITZ";
    ModeIds[ModeIds["RAPID"] = 5] = "RAPID";
    ModeIds[ModeIds["DAILY"] = 6] = "DAILY";
})(ModeIds || (ModeIds = {}));
export var TimeControl;
(function (TimeControl) {
    TimeControl[TimeControl["LIVE"] = 1] = "LIVE";
    TimeControl[TimeControl["DAILY"] = 2] = "DAILY";
})(TimeControl || (TimeControl = {}));
export var ModeNames;
(function (ModeNames) {
    ModeNames["CHESS960"] = "Chess960";
    ModeNames["BULLET"] = "Bullet";
    ModeNames["BLITZ"] = "Blitz";
    ModeNames["RAPID"] = "Rapid";
    ModeNames["DAILY"] = "D";
})(ModeNames || (ModeNames = {}));
export var LeagueNames;
(function (LeagueNames) {
    LeagueNames["PLACEMENT"] = "placement";
    LeagueNames["BRONZE"] = "bronze";
    LeagueNames["SILVER"] = "silver";
    LeagueNames["GOLD"] = "gold";
    LeagueNames["PLATINUM"] = "platinum";
    LeagueNames["DIAMOND"] = "diamond";
    LeagueNames["MASTER"] = "master";
    LeagueNames["GRAND_MASTER"] = "grandmaster";
})(LeagueNames || (LeagueNames = {}));
export var PlacementDivisions;
(function (PlacementDivisions) {
    PlacementDivisions[PlacementDivisions["CHESS960"] = 1] = "CHESS960";
    PlacementDivisions[PlacementDivisions["BULLET"] = 2] = "BULLET";
    PlacementDivisions[PlacementDivisions["BLITZ"] = 3] = "BLITZ";
    PlacementDivisions[PlacementDivisions["RAPID"] = 4] = "RAPID";
})(PlacementDivisions || (PlacementDivisions = {}));
export var RelationshipStatus;
(function (RelationshipStatus) {
    RelationshipStatus[RelationshipStatus["NONE"] = -1] = "NONE";
    RelationshipStatus[RelationshipStatus["PENDING"] = 0] = "PENDING";
    RelationshipStatus[RelationshipStatus["ACCEPTED"] = 1] = "ACCEPTED";
    RelationshipStatus[RelationshipStatus["DECLINED"] = 2] = "DECLINED";
    RelationshipStatus[RelationshipStatus["BLOCKED"] = 3] = "BLOCKED";
})(RelationshipStatus || (RelationshipStatus = {}));
export var AvatarTypes;
(function (AvatarTypes) {
    AvatarTypes[AvatarTypes["GUEST"] = 0] = "GUEST";
    AvatarTypes[AvatarTypes["DEFAULT"] = 1] = "DEFAULT";
    AvatarTypes[AvatarTypes["FACEBOOK"] = 2] = "FACEBOOK";
    AvatarTypes[AvatarTypes["UPLOAD"] = 3] = "UPLOAD";
    AvatarTypes[AvatarTypes["GOOGLE"] = 4] = "GOOGLE";
})(AvatarTypes || (AvatarTypes = {}));
export const DEFAULT_DEPTH = 15;
export const FREE_TIER = 1;
export const BASIC_TIER = 2;
export const REGULAR_TIER = 3;
export const UNLIMITED_TIER = 4;
export const TIERS = {
    [FREE_TIER]: "FREE",
    [BASIC_TIER]: "BASIC",
    [REGULAR_TIER]: "REGULAR",
    [UNLIMITED_TIER]: "UNLIMITED",
};
export const DAYLY_LEAGUE_GAMES = {
    [FREE_TIER]: 4,
    [BASIC_TIER]: 10,
    [REGULAR_TIER]: 20,
    [UNLIMITED_TIER]: "Unlimited",
};
export const DAYLY_GAME_REVIEWS = {
    [FREE_TIER]: 2,
    [BASIC_TIER]: 5,
    [REGULAR_TIER]: 10,
    [UNLIMITED_TIER]: "Unlimited",
};
export const DAYLY_ANALYZES = {
    [FREE_TIER]: 0,
    [BASIC_TIER]: 5,
    [REGULAR_TIER]: 10,
    [UNLIMITED_TIER]: "Unlimited",
};
export const GAMES_DATABASE = {
    [FREE_TIER]: "No database",
    [BASIC_TIER]: "Last 6 months",
    [REGULAR_TIER]: "Last 12 months",
    [UNLIMITED_TIER]: "Unlimited",
};
export const MAX_INVITES = 10;
export const CHESSPARTY_MIN_MOVES = 15;
export const USER = 3;
export const OPPONENT = 4;
export const USER_TIME_UP = 5;
export const OPPONENT_TIME_UP = 6;
export const OPPONENT_QUIT = 7;
export const OPPONENT_MATE = 8;
export const USER_MATE = 9;
export const OPPONENT_RESIGN = 10;
export const USER_RESIGN = 11;
export const STALE_MATE = 12;
export const DRAW = 13;
export const USER_QUIT = 14;
export const CHAT_USER = "CHAT_USER";
export const CHAT_OPPONENT = "CHAT_OPPONENT";
export const VARIANT_CHESS = 1;
export const VARIANT_CHESS960 = 2;
export const errorCodes = {
    ERROR_USERNAME_NOT_AVAILABLE: "ERROR_USERNAME_NOT_AVAILABLE",
    ERROR_FACEBOOK_ID_NOT_AVALABLE: "ERROR_FACEBOOK_ID_NOT_AVALABLE",
    ERROR_USERNAME_TOO_SHORT: "ERROR_USERNAME_TOO_SHORT",
    ERROR_USERNAME_TOO_LONG: "ERROR_USERNAME_TOO_LONG",
    ERROR_GENERAL: "ERROR_GENERAL",
    ERROR_EMAIL_NOT_VALID: "ERROR_EMAIL_NOT_VALID",
    ERROR_EMAIL_NOT_AVAILABLE: "ERROR_EMAIL_NOT_AVAILABLE",
    ERROR_PASSWORDS_DO_NOT_MATCH: "ERROR_PASSWORDS_DO_NOT_MATCH",
    ERROR_PASSWORD_TOO_SHORT: "ERROR_PASSWORD_TOO_SHORT",
    ERROR_PASSWORD_TOO_LONG: "ERROR_PASSWORD_TOO_LONG",
    ERROR_NO_COUNTRY: "ERROR_NO_COUNTRY",
};
export const MODE_ID_PRACTICE_CHESS = 10;
export const MODE_ID_PRACTICE_CHESS960 = 11;
export const MEMBERSHIP_PAGE = 100;
export const MEDALS_PAGE = 101;
export const LEAGUE_NAME_PLACEMENT = "placement";
export const LEAGUE_NAME_BRONZE = "bronze";
export const LEAGUE_NAME_SILVER = "silver";
export const LEAGUE_NAME_GOLD = "gold";
export const LEAGUE_NAME_PLATINUM = "platinum";
export const LEAGUE_NAME_DIAMOND = "diamond";
export const LEAGUE_NAME_MASTER = "master";
export const LEAGUE_NAME_GRANDMASTER = "grandmaster";
export const LEAGUE_ID_PLACEMENT = 8;
export const LEAGUE_ID_BRONZE = 1;
export const LEAGUE_ID_SILVER = 2;
export const LEAGUE_ID_GOLD = 3;
export const LEAGUE_ID_PLATINUM = 4;
export const LEAGUE_ID_DIAMOND = 5;
export const LEAGUE_ID_MASTER = 6;
export const LEAGUE_ID_GRANDMASTER = 7;
export const MAX_LEAGUE_ID = 6;
export const LEAGUE_IDS = {
    [LEAGUE_NAME_PLACEMENT]: LEAGUE_ID_PLACEMENT,
    [LEAGUE_NAME_BRONZE]: LEAGUE_ID_BRONZE,
    [LEAGUE_NAME_SILVER]: LEAGUE_ID_SILVER,
    [LEAGUE_NAME_GOLD]: LEAGUE_ID_GOLD,
    [LEAGUE_NAME_PLATINUM]: LEAGUE_ID_PLATINUM,
    [LEAGUE_NAME_DIAMOND]: LEAGUE_ID_DIAMOND,
    [LEAGUE_NAME_MASTER]: LEAGUE_ID_MASTER,
    [LEAGUE_NAME_GRANDMASTER]: LEAGUE_ID_GRANDMASTER,
};
export const LEAGUE_NAMES = {
    [LEAGUE_ID_PLACEMENT]: LEAGUE_NAME_PLACEMENT,
    [LEAGUE_ID_BRONZE]: LEAGUE_NAME_BRONZE,
    [LEAGUE_ID_SILVER]: LEAGUE_NAME_SILVER,
    [LEAGUE_ID_GOLD]: LEAGUE_NAME_GOLD,
    [LEAGUE_ID_PLATINUM]: LEAGUE_NAME_PLATINUM,
    [LEAGUE_ID_DIAMOND]: LEAGUE_NAME_DIAMOND,
    [LEAGUE_ID_MASTER]: LEAGUE_NAME_MASTER,
    [LEAGUE_ID_GRANDMASTER]: LEAGUE_NAME_GRANDMASTER,
};
export var LeagueResult;
(function (LeagueResult) {
    LeagueResult[LeagueResult["PLACEMENT"] = 0] = "PLACEMENT";
    LeagueResult[LeagueResult["UPGRADE"] = 1] = "UPGRADE";
    LeagueResult[LeagueResult["STANDARD"] = 2] = "STANDARD";
    LeagueResult[LeagueResult["ENTER_LEAGUE"] = 3] = "ENTER_LEAGUE";
    LeagueResult[LeagueResult["SIGN_UP"] = 4] = "SIGN_UP";
})(LeagueResult || (LeagueResult = {}));
export const BRONZE_LIMIT = 1100;
export const SILVER_LIMIT = 1180;
export const GOLD_LIMIT = 1260;
export const PLATINUM_LIMIT = 1350;
export const DIAMOND_LIMIT = 1450;
export const MASTER_LIMIT = 1550;
export const GRANDMASTER_LIMIT = 4000;
export const LEAGUE_LIMITS = {
    [LEAGUE_ID_BRONZE]: BRONZE_LIMIT,
    [LEAGUE_ID_SILVER]: SILVER_LIMIT,
    [LEAGUE_ID_GOLD]: GOLD_LIMIT,
    [LEAGUE_ID_PLATINUM]: PLATINUM_LIMIT,
    [LEAGUE_ID_DIAMOND]: DIAMOND_LIMIT,
    [LEAGUE_ID_MASTER]: MASTER_LIMIT,
};
export const CREATE_GAME_TAB = 1;
export const LIVE_GAME_TAB = 2;
export const DAILY_TAB = 3;
export const DAILY_GAMES_TAB = 4;
export const RECENT_CORR_TAB = 5;
export const INITIAL_LEAGUE_GAMES = 40;
export const INITIAL_ANALYZES = 10;
export const INITIAL_GAME_REVIEWS = 5;
export const MIN_GAME_NR_PER_LEAGUE = 30;
export const NOTIFICATION_DAILY_GAME_STARTED = 1;
export const NOTIFICATION_DAILY_GAME_FINISHED = 2;
export var ChessSets;
(function (ChessSets) {
    ChessSets["CHESSHOTEL"] = "chesshotel";
    ChessSets["STAUNTY"] = "staunty";
    ChessSets["CHESSHOTEL_NEW"] = "chesshotel_new";
})(ChessSets || (ChessSets = {}));
export var Board;
(function (Board) {
    Board["CHESSHOTEL"] = "chesshotel";
    Board["STAUNTY"] = "staunty";
    Board["BROWN"] = "brown";
})(Board || (Board = {}));
export var Pieces;
(function (Pieces) {
    Pieces["CHESSHOTEL"] = "chesshotel";
    Pieces["STAUNTY"] = "staunty";
})(Pieces || (Pieces = {}));
export var LobbyRoom;
(function (LobbyRoom) {
    LobbyRoom["MEMBERS"] = "members";
    LobbyRoom["DAILY"] = "daily";
    LobbyRoom["ALL"] = "all";
})(LobbyRoom || (LobbyRoom = {}));
export var StorageType;
(function (StorageType) {
    StorageType["PLAYER"] = "player_v2";
    StorageType["GAME"] = "game";
    StorageType["PING"] = "ping";
    StorageType["ACTIVE_WS"] = "active_ws";
})(StorageType || (StorageType = {}));
export var GameReviewStatus;
(function (GameReviewStatus) {
    GameReviewStatus["PARTIAL"] = "partial";
    GameReviewStatus["QUICK"] = "quick";
    GameReviewStatus["MEDIUM"] = "medium";
    GameReviewStatus["FINAL"] = "final";
})(GameReviewStatus || (GameReviewStatus = {}));
//# sourceMappingURL=index.js.map